export default class Deferred<T> {
	_resolve: (value?: T) => void = () => {};
	_reject: (value?: T) => void = () => {};

	_promise: Promise<T> = new Promise<T>((resolve, reject) => {
	    this._reject = reject;
	    this._resolve = resolve;
	});

	public get promise(): Promise<T> {
	    return this._promise;
	}

	public resolve(value?: T): void {
	    this._resolve(value);
	}

	public reject(value?: any): void {
	    this._reject(value);
	}
}
